import Link from "next/link";
import Image from "next/image";
import logoText from "@/public/logo/logo-text-2.svg";

export default function ResponsiveLogo() {
  return (
    <>
      {/* Logo: top-left on lg+, centered above form on mobile */}
      <div className="hidden lg:block fixed top-8 left-8 z-10">
        <Link href="/">
          <Image src={logoText} alt="QuickNHS Logo" width={180} height={60} priority />
        </Link>
      </div>
      <div className="block lg:hidden mb-8 w-full flex justify-center items-center">
        <Link href="/">
          <Image src={logoText} alt="QuickNHS Logo" width={200} height={60} priority />
        </Link>
      </div>
    </>
  );
}
